import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-user-social-info-panel',
  templateUrl: './user-social-info-panel.component.html',
  styleUrls: ['./user-social-info-panel.component.scss']
})
export class UserSocialInfoPanelComponent implements OnInit {
  @Input() user: User;
  
  constructor() { }

  ngOnInit() {
  }

}
